module.exports = __webpack_public_path__ + "img/CodeForHamburg.dff914df.svg";